module.exports = __webpack_public_path__ + "img/icon_youshi01.3fee2340.png";